export default __webpack_public_path__ + "static/media/dashboard.6d9814ac.svg";